<div class="section" id="about">
    <div class="container">
      <div class="card"  data-aos-offset="10">
        <div class="row">
          <div class="col-lg-6 col-md-12" data-aos="fade-right">
            <div class="card-body">
              <div class="h4 mt-0 title">About</div>
              <hr>
              <p>Hi I'm <strong>Nisa Champagne</strong> , a Software Professional currently working as a Software Developer II at Goodville Mutual Casualty Company, Napoleon, OH

              <p>       
                  I have a keen interest in learning new technologies and deep diving to explore.
                                        
              </p>
              <p>Having <strong> 3 years </strong>  of experience in the IT Industry (~9 months of technical experience in a school setting) has helped harness skills in various technologies and tools.
                I have tried to express and share my experience and knowledge through dev.to. Check out my contributions at:
              <strong> https://dev.to/nisachampagne </strong></p>

                 
            </div>
          </div>
          <div class="col-lg-6 col-md-12" data-aos="fade-left">
            <div class="card-body">
              <div class="h4 mt-0 title">Basic Information</div>
              <hr>
    
              <div class="row mt-3">
                <div class="col-sm-4">
                  <strong class="text-uppercase">Email:</strong>
                </div>
                <div class="col-sm-8">nchampag23@gmail.com</div>
              </div>
              <div class="row mt-3">
                <div class="col-sm-4">
                  <strong class="text-uppercase">Phone:</strong>
                </div>
                <div class="col-sm-8">813-344-8993</div>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>